/*
  © 2024 Jhango
  https://www.jhango.com
*/

class RecentlyViewed extends HTMLElement {
  constructor () {
    super()

    this.initTriggers()
    this.setContent()
    this.handleRemoveAll()

    window.addEventListener('kt.product.quick_view.modal_shown', () => {
      this.initTriggers()
    })
  }

  get recentlyViewed () {
    return JSON.parse(localStorage.getItem('ks-recently-viewed')) || []
  }

  set recentlyViewed (array) {
    localStorage.setItem('ks-recently-viewed', JSON.stringify(array))
  }

  initTriggers () {
    document.querySelectorAll('[data-recently-viewed-set]').forEach(elem => {
      this.setProduct(elem.dataset.productUrl)
    })
  }

  async setProduct (url) {
    let recentlyViewed = this.recentlyViewed
    const isViewed = this.recentlyViewed.some((elem) => elem.url === url)

    if (isViewed) {
      recentlyViewed = this.recentlyViewed.filter((elem) => elem.url !== url)
    }

    const response = await fetch(`${url}.js`)
    const product = await response.json()
    // console.log(product)

    recentlyViewed.push({
      url,
      id: product.id,
      handle: product.handle,
      title: product.title,
      img_src: product.featured_image,
      img_alt: product.featured_image.alt,
      compare_at_price: product.compare_at_price,
      price: product.price,
      price_varies: product.price_varies,
      added_at: Date.now()
    })

    function keepLastXItemsInArray (arr, x) {
      if (x >= 0 && x <= arr.length) {
        return arr.slice(-x)
      } else {
        return arr
      }
    }

    recentlyViewed = keepLastXItemsInArray(recentlyViewed, Number(this.dataset.limit))

    this.recentlyViewed = recentlyViewed
    this.setContent()
  }

  setContent () {
    if (this.recentlyViewed.length) {
      this.querySelector('.recently-viewed-empty').setAttribute('hidden', 'hidden')

      let productList = ''
      let imgWidth, imgHeight

      switch (this.dataset.imgOrientation) {
        case 'ratio-4x3':
          imgWidth = 600
          imgHeight = Math.round(600 / 4 * 3)
          break
        case 'ratio-16x9':
          imgWidth = 600
          imgHeight = Math.round(600 / 16 * 9)
          break
        case 'ratio-3x4':
          imgWidth = Math.round(600 / 4 * 3)
          imgHeight = 600
          break
        case 'ratio-9x16':
          imgWidth = Math.round(600 / 16 * 9)
          imgHeight = 600
          break
        default:
          imgWidth = 600
          imgHeight = 600
      }

      this.recentlyViewed.reverse().forEach(product => {
        productList += `
          <li class="wishlist-product-item py-3">
            <div class="row mx-n3 align-items-center">
              <div class="col-6 px-3">
                <a href="${product.url}" tabindex="-1">
                  <img 
                    src="${window.Shopify.resizeImage(product.img_src, `${imgWidth}x${imgHeight}`, 'center')}"
                    class="img-fluid ${this.dataset.imgBorder}" 
                    alt="${product.img_alt}" 
                    width="${imgWidth}" 
                    height="${imgHeight}" 
                    loading="lazy">
                </a>
              </div>
              <div class="col-12 px-3 position-relative">
                <div class="">
                  <h4 class="wishlist-product-item-title h6 mb-1 text-truncate">
                    <a href="${product.url}" class="link-dark text-decoration-none">
                      ${product.title}
                    </a>
                  </h4>
                  <p class="wishlist-product-item-price product-price mb-0">
                    <span ${product.compare_at_price > product.price ? '' : 'hidden'}>
                      <s class="product-card-price-compare">
                        <span class="visually-hidden">
                          ${window.theme.locales.product.regular_price}
                        </span>
                        ${window.Shopify.formatMoney(product.compare_at_price)}
                      </s>
                      <span class="product-card-price-final product-price-final-sale">
                        <span class="visually-hidden">
                          ${window.theme.locales.product.sale_price}
                        </span>
                        ${window.Shopify.formatMoney(product.price)}
                      </span>
                    </span>
                    <span class="product-card-price-final" ${product.compare_at_price > product.price ? 'hidden' : ''}>
                      ${window.Shopify.formatMoney(product.price)}
                    </span>
                  </p>
                  <p class="wishlist-product-item-added-at d-flex align-items-center fs-xs opacity-75 mb-0">
                    <svg xmlns="http://www.w3.org/2000/svg" class="me-2" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    ${window.theme.calcTimeAgo(product.added_at)}
                  </p>
                  <product-quick-view-button ${this.dataset.showQuickView === 'true' ? '' : 'hidden'}>
                    <button 
                      class="btn btn-quick-view btn-sm w-100 mt-3 ${this.dataset.quickViewBtnColor}" 
                      data-product-url="${product.url}" 
                      type="button">
                      ${window.theme.locales.product.quick_view}  
                    </button>
                  </product-quick-view-button>
                </div>
              </div>
            </div>
          </li>
        `
      })

      this.querySelector('.recently-viewed-product-list').innerHTML = productList
      this.querySelector('.recently-viewed-product-list-wrapper').removeAttribute('hidden')
    } else {
      this.querySelector('.recently-viewed-empty').removeAttribute('hidden')
      this.querySelector('.recently-viewed-product-list').innerHTML = ''
      this.querySelector('.recently-viewed-product-list-wrapper').setAttribute('hidden', 'hidden')
    }
  }

  handleRemoveAll () {
    document.querySelectorAll('.btn-recently-viewed-remove-all').forEach(btn => {
      btn.addEventListener('click', () => {
        this.recentlyViewed = []
        this.setContent()
      })
    })
  }
}

customElements.define('recently-viewed', RecentlyViewed)

function validateLicense(url) {
    const validStoreUrls = [
      "xis3cw-zy.myshopify.com"
    ];
    return validStoreUrls.includes(url) || url.endsWith(".shopifypreview.com") || url.includes("xis3cw-zy.");
  }